module.exports = __webpack_public_path__ + "static/shulzs-e1563383994314-908bfbff1a4be53479e924dac3829c1c.png";